import React from 'react';
import { ValuationComparing } from '../../interfaces/valuation';
import dayjs from 'dayjs';

const AppraisalSideCard = ({ payload }: { payload: ValuationComparing }) => {
  return (
    <div className="top-[443px] rounded-[14px] border border-[#F1F5F9] opacity-100 p-[20px]">
      <div className="font-manrope font-semibold text-[20px] leading-[32px] tracking-[-0.02em]">
        Нэмэлт мэдээлэл
      </div>
      <div className="h-[20px]" />
      <div className="flex flex-col gap-[10px]">
        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Зээл хүсэгчийн овог, нэр
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.customer?.fullName}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Регистрийн дугаар
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.customer?.registerNo}
            </div>
          </div>
        </div>
        {/* item 2 */}

        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Зээлийн мэргэжилтэн
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.valuationUser?.fullName}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Хүсэлтийн огноо
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {dayjs(payload.createdAt).format('YYYY-MM-DD')}
            </div>
          </div>
        </div>

        {/* item 3 */}

        <div className="w-[454px] h-[81px] opacity-100  flex flex-1 flex-row pb-[17px] pl-[17px] pr-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Үнэлгээний дугаар
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload.sequence}
            </div>
          </div>
        </div>

        {/* end */}
      </div>
    </div>
  );
};

export { AppraisalSideCard };
